import * as yup from 'yup';

const RenameMediaValidationSchema = yup.object({
  name: yup.string().trim().required('File name is required').max(256, 'File name must be at least 256 characters')
    .min(3, 'File name must be at least 3 characters'),
});

export default RenameMediaValidationSchema;
